import type { FormInputAppearance } from '../models/built-form';

export function previewShellWidthClass(mode: 'desktop' | 'mobile'): string {
  const base = 'mx-auto w-full transition-all duration-300';

  if (mode === 'mobile') {
    return `${base} max-w-sm`;
  }

  return `${base} max-w-3xl`;
}

export function previewControlClass(appearance?: FormInputAppearance): string {
  const base =
    'w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm leading-6 text-slate-900 disabled:cursor-default disabled:opacity-100';

  switch (appearance ?? 'fill') {
    case 'outline':
      return `${base} border-slate-300`;
    case 'ghost':
      return `${base} rounded-none border-0 border-b border-slate-300 bg-transparent px-0`;
    case 'floating':
      return `${base} border-0 bg-slate-50 py-3.5`;
    case 'ifta':
      return `${base} bg-slate-50 pb-2 pt-3.5`;
    case 'floatingOutline':
      return `${base} border-slate-300 py-3.5`;
    default:
      return `${base} bg-slate-50`;
  }
}
